module.exports = __webpack_public_path__ + "img/BOC.4aeec5ea.png";